import { render, staticRenderFns } from "./productListFromBank.vue?vue&type=template&id=4ec7c86c&scoped=true&"
import script from "./productListFromBank.vue?vue&type=script&lang=js&"
export * from "./productListFromBank.vue?vue&type=script&lang=js&"
import style0 from "./productListFromBank.vue?vue&type=style&index=0&id=4ec7c86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7c86c",
  null
  
)

export default component.exports